import styled from 'styled-components';

export const Container = styled.div<{ width: number }>`
  position: relative;
  border-left: 1px solid #e5e5e5;
  width: ${({ width }) => width}px;
  height: calc(100vh - 108px);
  align-self: flex-start;
`;

export const DraggableArea = styled.div`
  position: absolute;
  left: -2px;
  top: 0;
  width: 3px;
  height: 100%;
  z-index: 2;
  cursor: col-resize;
  background-color: #382152;
  opacity: 0;
  transition: opacity 0.2s ease;
  transition-delay: 0.1s;

  &:hover {
    opacity: 1;
  }
`;

export const ScrollableWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const HighlightText = styled.div`
  position: relative;
  padding-left: 8px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 16px;

  &::before {
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    height: 100%;
    width: 3px;
    background-color: #e4e4e4;
  }
`;

export const CloseIcon = styled.div`
  position: absolute;
  right: 6px;
  top: 6px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  color: rgba(59, 38, 81, 0.4);
`;

export const TagsBlock = styled.div<{ selected?: boolean }>`
  position: relative;
  padding: 20px 20px 12px;
  border-bottom: 1px solid #e4e4e4;
  cursor: pointer;
  background-color: ${({ selected }) => (selected ? '#F8F6FA' : '#ffffff')};

  &:hover ${CloseIcon} {
    display: flex;
  }
`;

export const Tag = styled.div<{ color?: string }>`
  background-color: ${({ color }) => (color ? color : 'rgba(56, 33, 82, 0.2)')};
  border-radius: 3px;
  padding: 3px 5px;
  margin-right: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #382152;
  flex-shrink: 0;
  margin-bottom: 8px;
`;

export const Tags = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: wrap;
`;

export const StartTime = styled.div`
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  color: rgba(59, 38, 81, 0.4);
  margin-bottom: 10px;
`;

export const DocumentTags = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const ColoredCircle = styled.div<{ color?: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ color }) => (color ? color : 'rgba(56, 33, 82, 0.2)')};
  margin-right: 4px;
`;

export const ParticipantContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const ParticipantName = styled.div`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  margin-left: 5px;
`;

export const CreatedByText = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
  font-weight: 500;
  color: rgba(59, 38, 81, 0.4);
  flex-wrap: wrap;
`;

export const SmartStarsIcon = styled.div`
  margin: 0 5px;
`;
